(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('AlertModalService', AlertModalService);

    AlertModalService.$inject = ['$injector', 'ModalConstructor'];

    function AlertModalService($injector, ModalConstructor) {

        return {
            error: error,
            errorWithMsg: errorWithMsg,
            success: success,
            wait: wait,
            warning: warning
        };

        // Configure and open the error modal
        function error(response, action, state) {

            // Error modal controller dependencies injection
            errorController.$inject = ['$uibModalInstance', '$translate'];

            // Check if the error was already called from the interceptor or cancelled
            if (!response.intercepted && !(response.config && response.config.canceled)) {

                // Configure the error modal
                var errorTemplate = {
                    windowTemplateUrl: 'app/shared/alert/alert-error-modal.html',
                    templateUrl: 'app/shared/alert/alert-error.html',
                    controller: errorController,
                    controllerAs: 'vmAlertError',
                    size: 'sm',
                    windowClass: 'modal-alert modal-error',
                    avoidCancel: true
                };

                // Open the error modal
                return ModalConstructor.open(errorTemplate);

            }

            // Error modal controller
            function errorController($uibModalInstance, $translate) {

                var status = response.status;
                var vm = this;
                vm.close = close;
                vm.detailCollapsed = true;
                vm.toggleDetail = toggleDetail;

                // If the response data has a property cause, concatenate to the status code
                // This is used to create keys for errors 412.1, 412.2, etc
                if (response.data && response.data.cause) {
                    // Cause 5 is the generic cause
                    if (response.data.cause.toString() === '5') {
                        status = response.data.message;
                    } else {
                        status += '.' + response.data.cause;
                    }
                }

                // Generate the translation key based on action, state and error status
                var modalMessage = state + 'Error.responseError.' + action + '.message.error.' + status;

                // Try to translate the key
                $translate(modalMessage).then(translationExists).catch(translationError);

                // If the key exists sets the view message to it
                function translationExists() {
                    vm.modalMessage = modalMessage;

                    // Check for errors with status 412
                    if (response.status.toString() === '412') {
                        // Sets the device name in the error message
                        vm.equipmentName = response.data.name || response.config.data.name;

                        // If the cause is 0 and there is a printout defines the error detail
                        if (response.data.cause.toString() === '0' && response.data.printout) {
                            var errorMessage = response.data.printout.replace(/\r/g, '\n');
                            var firstBreak = errorMessage.indexOf('\n');
                            vm.errorDetail = {
                                command: errorMessage.slice(0, firstBreak),
                                printout: errorMessage.slice(firstBreak, errorMessage.lastIndexOf('\n'))
                            };
                        }
                    }
                }

                // If the translation doesn't exists sets the view message to unknown error
                function translationError() {
                    vm.modalMessage = 'globalError.responseError.default.message.error.500';
                }

                // Close the modal
                function close() {
                    $uibModalInstance.dismiss('cancel');
                }

                // Toggle the error detail
                function toggleDetail() {
                    vm.detailCollapsed = !vm.detailCollapsed;
                    vm.modalSize = vm.detailCollapsed ? 'modal-sm' : 'modal-lg';
                }

            }

        }

        function errorWithMsg(msg) {
            errorWithMsgController.$inject = ['$uibModalInstance'];

            var errorWithMsgTemplate = {
                windowTemplateUrl: 'app/shared/alert/alert-error-modal.html',
                templateUrl: 'app/shared/alert/alert-error.html',
                controller: errorWithMsgController,
                controllerAs: 'vmAlertError',
                size: 'sm',
                windowClass: 'modal-alert modal-error',
                avoidCancel: true
            };

            function errorWithMsgController($uibModalInstance) {
                var vm = this;
                vm.close = close;

                vm.modalMessage = msg;

                function close() {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            // Open the error modal
            return ModalConstructor.open(errorWithMsgTemplate);
        }

        // Configure and open the success modal
        // success ex: success('restart', true, 'olt')
        function success(action, isMultiple, state, dontCloseAll) {

            var UserData = $injector.get('UserData');

            if (!UserData.sessionExpired) {

                var alertType = isMultiple ? 'multiple' : 'single';

                successController.$inject = ['$uibModalInstance'];

                // Configure the success modal
                var successTemplate = {
                    templateUrl: 'app/shared/alert/alert-success.html',
                    controller: successController,
                    controllerAs: 'vmAlertSuccess',
                    size: 'md',
                    windowClass: 'modal-alert modal-success',
                    avoidCancel: true
                };

                // Open the success modal
                return ModalConstructor.open(successTemplate);

            }

            // Success modal controller
            function successController($uibModalInstance) {

                // Generate the translation key based on action and state
                this.modalMessage = state + 'Success.response.' + action + '.message.' + alertType;

                // Close the modal
                this.close = function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                }

                $uibModalInstance.result.finally(function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    }
                });
            }

        }

        // Configure and open the wait modal
        function wait(activity, action) {

            // Configure the wait modal
            var waitTemplate = {
                templateUrl: 'app/shared/alert/alert-wait.html',
                controller: waitController,
                controllerAs: 'vmAlertWait',
                size: 'sm',
                windowClass: 'modal-alert modal-wait',
                backdrop: 'static',
                backdropClass: 'backdrop-wait',
                keyboard: false
            };

            // Open the wait modal
            if (activity) {
                ModalConstructor.open(waitTemplate);
            } else {
                ModalConstructor.closeAll();
            }

            // Wait modal controller
            waitController.$inject = ['$uibModalInstance'];
            function waitController($uibModalInstance) {

                // Generate the translation key based on action
                this.modalMessage = 'globalWait.' + action + '.message';

                // Close the modal
                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                }

            }

        }

        // Configure and open the warning modal
        function warning(list, response, action, state, dontCloseAll) {

            // Configure the warning modal
            var warningTemplate = {
                templateUrl: 'app/shared/alert/alert-warning.html',
                controller: warningController,
                controllerAs: 'vmAlertWarning',
                size: 'sm',
                windowClass: 'modal-alert modal-warning',
                avoidCancel: true
            };

            // Store the original items list
            var originalList = angular.copy(list);

            warningController.$inject = ['$uibModalInstance', '$filter'];

            // Open the warning modal
            return ModalConstructor.open(warningTemplate);

            // Success modal controller
            function warningController($uibModalInstance, $filter) {

                // Generate the translation key based on action and state
                this.modalMessage = state + 'Warning.response.' + action + '.message.error.' + response.status;

                this.list = response.data.map(function (responseItem) {
                    if (!responseItem.name) {
                        return $filter('filter')(originalList, {id: responseItem.id}, true)[0].name;
                    }
                    return responseItem.name;
                }).join(', ');

                // Close the modal
                this.close = function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                }

                $uibModalInstance.result.finally(function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    }
                });
            }

        }

    }
})();
